import type { MarketingBannerRow, MarketingBannersTranslations } from "./types";

import { DotsVerticalIcon, DownloadIcon, EditIcon, EyeIcon } from "../Icons";
import { PopoverMenu } from "../PopoverMenu";
import { BannerButtonText, BannerCopyButtonText } from "./BannerButtonText";

export const BannerMoreOptionsPopoverMenu = ({
  banner,
  translations,
  onView,
  onCopy,
  onRename,
  onDownload,
  onMenuOpen,
  isMobile,
}: {
  banner: MarketingBannerRow;
  translations: MarketingBannersTranslations;
  onView?: () => void;
  onCopy?: () => void;
  onRename?: () => void;
  onDownload?: () => void;
  onMenuOpen?: () => void;
  isMobile?: boolean;
}) => {
  const { copyLabel } = translations.actions.getCopyLabels(banner.type);

  const isBannerImage = banner.type === "image_banner";

  if (isMobile) {
    return (
      <button
        type="button"
        aria-label="More options"
        className="flex h-8 w-8 items-center justify-center rounded-lg border border-stroke-primary text-text-primary"
        onClick={onMenuOpen}
      >
        <DotsVerticalIcon className="h-4 w-4" />
      </button>
    );
  }

  return (
    <PopoverMenu
      content={
        <div className="flex w-[200px] flex-col items-start justify-stretch p-4">
          <BannerButtonText
            icon={<EyeIcon width={16} height={16} />}
            text={translations.actions.view}
            onClick={onView}
          />
          <BannerCopyButtonText
            copyLabel={copyLabel}
            copiedLabel={translations.actions.copied}
            text={banner.creative_code}
            onClick={onCopy}
            iconSize={16}
          />
          <BannerButtonText
            icon={<EditIcon width={16} height={16} />}
            text={translations.actions.rename}
            onClick={onRename}
          />
          {isBannerImage && (
            <BannerButtonText
              icon={
                <DownloadIcon
                  width={16}
                  height={16}
                  className="[&_path]:stroke-text-primary"
                />
              }
              text={translations.actions.downloadPng}
              onClick={onDownload}
            />
          )}
        </div>
      }
    >
      <button
        type="button"
        aria-label="More options"
        className="flex h-6 w-6 items-center justify-center rounded-lg text-text-brand-default hover:bg-overlay-opacity-state-hover"
        onClick={onMenuOpen}
      >
        <DotsVerticalIcon className="h-4 w-4" />
      </button>
    </PopoverMenu>
  );
};
